export default __webpack_public_path__ + "static/media/somaliland.3326c079.svg";